import { gql } from "@apollo/client";
import moment from "moment";

export const GET_CONDICIONES_CONTRATO = gql`
query condicionContrato($idEvaluacion: Int!) {
    condicionContrato(
        idEvaluacion: $idEvaluacion
    ) {
        fechaDesde
        fechaHasta
        diasCorridosContrato
        diasTratamiento
        ivaPaciente
        condicionCliente
        condicionClienteDesc
        precioDiario
        observacion
        cotizado
        ajustePrestacion
        precioControl
        vigencia
        tipoPrecio
        condicional
        estadoPrecio{
            idAutorizacionControlEstado
        }
    }
}`;


export const adaptCondicionesContrato = (data) => {
  return {
    fechaDesde: data?.condicionContrato?.fechaDesde,
    fechaHasta: data?.condicionContrato?.fechaHasta,
    diasCorridosContrato: data?.condicionContrato?.diasCorridosContrato,
    diasTratamiento: data?.condicionContrato?.diasTratamiento,
    ivaPaciente: data?.condicionContrato?.ivaPaciente,
    condicionCliente: data?.condicionContrato?.condicionCliente,
    condicionClienteDesc: data?.condicionContrato?.condicionClienteDesc,
    precioDiario: data?.condicionContrato?.precioDiario,
    estadoPrecio: data?.condicionContrato?.estadoPrecio?.idAutorizacionControlEstado,
    tipoPrecio: data?.condicionContrato?.tipoPrecio,
    vigencia: data?.condicionContrato?.vigencia,
    precioControl: data?.condicionContrato?.precioControl,
    observacion: data?.condicionContrato?.observacion,
    cotizado: data?.condicionContrato?.cotizado,
    ajustePrestacion: data?.condicionContrato?.ajustePrestacion,
    condicional: data?.condicionContrato?.condicional
  };
};